import React, { ComponentProps, forwardRef } from 'react';
import { ExpertCardListings } from '@fiverr-private/listings';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { AppI18n } from '../../../i18n';

interface Props {
    isMatchSellersLoading: boolean;
    sellersWithCTA: any[];
}

export const Listings = forwardRef<HTMLElement, Props>(
    ({ isMatchSellersLoading, sellersWithCTA }: Props, forwardRef) => {
        const listingsPadding: ComponentProps<typeof Stack> = {
            padding: '8',
            paddingTop: { default: '6', md: '8' },
            paddingLeft: { default: '8', md: '6' },
        };

        return (
            <Container
                ref={forwardRef}
                flexGrow={1}
                overflow={{ md: 'auto' }}
                paddingTop={{ default: '0', md: isMatchSellersLoading ? '2' : '8' }}
            >
                <Stack
                    {...(isMatchSellersLoading ? {} : listingsPadding)}
                    flexGrow={1}
                    direction="column"
                    paddingTop={{ default: '12', md: '0' }}
                >
                    <Typography
                        hidden={{ default: false, md: true }}
                        style={{ fontWeight: '280' }}
                        size="h_xl"
                        textAlign="center"
                        maxWidth="300px"
                        alignSelf="center"
                    >
                        <AppI18n k="listings.title" />
                    </Typography>
                    <ExpertCardListings
                        isLoading={isMatchSellersLoading}
                        items={sellersWithCTA}
                        source="vibe_coding"
                        cardVariant="visual"
                        displayOptions={{
                            showHeaderSaveExpert: false,
                            showHeaderContact: false,
                            showHeaderSeeProfile: false,
                            showSeeProfile: false,
                            showSaveExpert: true,
                        }}
                    />
                </Stack>
            </Container>
        );
    }
);

Listings.displayName = 'Listings';
